import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex p-0 m-0 justify-content-end align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-0 mr-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-paperclip" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"1rem"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex p-0 m-0 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmChangesDialog = _resolveComponent("ConfirmChangesDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_AddAttachmentDialog = _resolveComponent("AddAttachmentDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ConfirmChangesDialog, { ref: "confirmChanges" }, null, 512),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.hostFile !== 'CUST' && _ctx.showTotalAttachments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", {
                class: "ml-2 link",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAttachmentsLog && _ctx.viewAttachmentsLog(...args)))
              }, [
                _createTextVNode("Total Attachments: "),
                (_ctx.loadingAttachments)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.totalAttachments), 1))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Add Attachment",
            icon: "pi pi-plus",
            class: "h-2rem text-sm",
            id: "newAttachment",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddTicketAttachmentDialog = true))
          })
        ])
      ])
    ]),
    (_ctx.tempAttachmentRecords.length > 0)
      ? (_openBlock(), _createBlock(_component_Datatable, {
          key: 0,
          value: _ctx.tempAttachmentRecords,
          class: "p-datatable-sm bordered-table",
          hidden: _ctx.isAttachmentLogVisible,
          responsiveLayout: "stack",
          breakpoint: "991px"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(" No attachments to display. ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "doc_name",
              header: "Document",
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              field: "folder",
              header: "Folder",
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              field: "user_id",
              header: "Created By",
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              field: "desc",
              header: "Description",
              style: {"line-break":"anywhere","word-break":"keep-all"},
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              bodyClass: "text-center",
              bodyStyle: "width: 150px"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    id: "deleteButton",
                    icon: _ctx.deleteIcon(slotProps.data.doc_name),
                    title: "Delete",
                    class: "remove",
                    onClick: ($event: any) => (_ctx.confirmDelete(slotProps.data.doc_name))
                  }, null, 8, ["icon", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "hidden"]))
      : _createCommentVNode("", true),
    (_ctx.tempAttachmentRecords.length === 0)
      ? (_openBlock(), _createBlock(_component_Datatable, {
          key: 1,
          id: "attachmentsTable",
          loading: _ctx.loadingAttachments,
          value: _ctx.attachmentRecords,
          hidden: _ctx.isAttachmentLogVisible,
          paginator: true,
          rows: _ctx.rows,
          first: _ctx.first,
          onPage: _ctx.handlePage,
          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
          currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
          rowsPerPageOptions: [5, 10, 25, 50],
          class: "p-datatable-sm bordered-table",
          responsiveLayout: "stack",
          breakpoint: "991px"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(" No attachments to display. ")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "file_name",
              header: "Document",
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              field: "created_by",
              header: "Created By",
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }),
            _createVNode(_component_Column, {
              field: "date_created",
              header: "Date",
              bodyClass: "text-center",
              headerClass: "column-header-center"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(_ctx.getDate(slotProps.data)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "time_created",
              header: "Time",
              bodyClass: "text-center",
              headerClass: "column-header-center"
            }),
            _createVNode(_component_Column, {
              header: "Description",
              style: {"line-break":"anywhere","word-break":"keep-all"},
              bodyClass: "text-left",
              headerClass: "column-header-left"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.description), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "value", "hidden", "rows", "first", "onPage"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AddAttachmentDialog, {
      isLoadingAttachment: _ctx.isUploading,
      show: _ctx.showAddTicketAttachmentDialog,
      onHide: _cache[2] || (_cache[2] = 
        (isHidden) => {
          _ctx.showAddTicketAttachmentDialog = isHidden;
        }
      ),
      onOnUploadAttachment: _ctx.saveAttachment
    }, null, 8, ["isLoadingAttachment", "show", "onOnUploadAttachment"])
  ]))
}